const vi = {
    // Navigation
    'nav.overview': 'Chấm công',
    'nav.payslip': 'Phiếu lương',
    'nav.calendar': 'Lịch',
    'nav.contact': 'Danh bạ',
    'nav.profile': 'Hồ sơ',
    'nav.amercement': 'Bảng phong thần',
    'nav.rules': 'Nội quy',
    'nav.admin': 'Quản trị',
    'nav.attendance': 'Chấm công',
    'nav.leave': 'Nghỉ phép',
    'nav.overtime': 'Làm thêm giờ',
    'nav.payroll': 'Bảng lương',
    'nav.setting': 'Cài đặt',
    'nav.rulesEditor': 'Nội quy',

    // Header
    'header.logout': 'Đăng xuất',
    'header.switchToEnglish': 'Chuyển sang tiếng Anh',
    'header.switchToVietnamese': 'Chuyển sang tiếng Việt',

    // Language
    'language.english': 'English',
    'language.vietnamese': 'Tiếng Việt',

    // Calendar
    'calendar.upcomingEvents': 'Sự kiện sắp tới',
    'calendar.addNewEvent': 'Thêm sự kiện mới',
    'calendar.createEvent': 'sự kiện',
    'calendar.category': 'Danh mục',
    'calendar.title': 'Tiêu đề',
    'calendar.start': 'Bắt đầu',
    'calendar.end': 'Kết thúc',
    'calendar.dayOff': 'Ngày nghỉ',
    'calendar.companyEvent': 'Sự kiện công ty',
    'calendar.paidHoliday': 'Nghỉ có lương',
    'calendar.weekend': 'Cuối tuần',
    'calendar.holiday': 'Ngày lễ',
    'calendar.event': 'Sự kiện',
    'calendar.meeting': 'Cuộc họp',
    'calendar.birthday': 'Sinh nhật',
    'calendar.teamBuilding': 'Team building',
    'calendar.partyDay': 'Quẩy time',
    'calendar.chillingDay': 'Ngày thư giãn',
    'calendar.happyHoliday': 'Chúc kỳ nghỉ vui vẻ',
    'calendar.happyBirthday': 'Chúc mừng sinh nhật',
    'calendar.eventDefault': 'Sự kiện',

    // Common
    'common.save': 'Lưu',
    'common.cancel': 'Hủy',
    'common.update': 'Cập nhật',
    'common.search': 'Tìm kiếm',
    'common.export': 'Xuất file',
    'common.approve': 'Duyệt',
    'common.reject': 'Từ chối',
    'common.loading': 'Đang tải...',
    'common.actions': 'Thao tác',
    'common.delete': 'Xóa',
    'common.add': 'Thêm',
    'common.edit': 'Sửa',
    'common.no': 'STT',
    'common.name': 'Họ và tên',
    'common.email': 'Email',
    'common.month': 'Tháng',
    'common.year': 'Năm',
    'common.status': 'Trạng thái',
    'common.note': 'Ghi chú',
    'common.from': 'Từ',
    'common.to': 'Đến',
    'common.date': 'Ngày',
    'common.type': 'Loại',
    'common.reason': 'Lý do',
    'common.total': 'Tổng',
    'common.detail': 'Chi tiết',
    'common.back': 'Quay lại',
    'common.confirm': 'Xác nhận',
    'common.success': 'Thành công',
    'common.error': 'Lỗi',
    'common.warning': 'Cảnh báo',
    'common.info': 'Thông tin',
    'common.min': 'phút',

    // Admin Rules Editor
    'adminRuleEditor.title': 'Nội quy',

    // Admin Setting
    'adminSetting.title': 'Cài đặt',
    'adminSetting.allowedIPs': 'Danh sách IP cho phép',
    'adminSetting.addIP': 'Thêm IP',
    'adminSetting.workingRules': 'Quy tắc làm việc',
    'adminSetting.ipAddress': 'Địa chỉ IP',

    // Profile
    'profile.title': 'Hồ sơ cá nhân',
    'profile.fullName': 'Họ và tên',
    'profile.email': 'Email',
    'profile.role': 'Chức vụ',
    'profile.cccd': 'CCCD',
    'profile.phone': 'Số điện thoại',
    'profile.birthday': 'Ngày sinh',
    'profile.gender': 'Giới tính',
    'profile.male': 'Nam',
    'profile.female': 'Nữ',
    'profile.address': 'Địa chỉ',
    'profile.dateOfJoining': 'Ngày gia nhập',
    'profile.bankAccount': 'Số tài khoản',
    'profile.bankName': 'Ngân hàng',
    'profile.updateProfile': 'Cập nhật hồ sơ',

    // Payslip
    'payslip.title': 'Phiếu lương',
    'payslip.salary': 'Lương',
    'payslip.workingDays': 'Ngày công',
    'payslip.totalWorkingDays': 'Tổng ngày công',
    'payslip.paidWorkingDays': 'Ngày công tính lương',
    'payslip.paidLeave': 'Nghỉ có phép',
    'payslip.annualLeave': 'Nghỉ phép năm',
    'payslip.leaveDay': 'Ngày nghỉ',
    'payslip.absentDay': 'Ngày vắng',
    'payslip.bonus': 'Thưởng',
    'payslip.deduction': 'Khấu trừ',
    'payslip.netIncome': 'Thực lĩnh',
    'payslip.personalTax': 'Thuế TNCN',
    'payslip.export': 'Xuất phiếu lương',
    'payslip.approve': 'Duyệt lương',
    'payslip.showSalary': 'Hiển thị lương',
    'payslip.amercement': 'Phạt',
    'payslip.checkInLate': 'Đi muộn',
    'payslip.requestDeclined': 'Yêu cầu bị từ chối',
    'payslip.otherAmercement': 'Phạt khác',
    'payslip.workingDayPlan': '(1) Ngày công tháng',
    'payslip.paidWorkingDay': '(2) Ngày công tính lương',
    'payslip.actualWorkingDay': '(2.1) Ngày công thực tế',
    'payslip.paidLeaveDay': '(2.2) Nghỉ có phép',
    'payslip.unpaidLeaveDay': '(2.3) Nghỉ không lương',
    'payslip.annualLeaveDay': '(2.4) Nghỉ phép năm',
    'payslip.remainAnnualLeaves': '(3) Phép năm còn lại',
    'payslip.earnings': 'A. Thu nhập',
    'payslip.baseSalary': 'Lương hợp đồng',
    'payslip.paidWorkingDayLabel': 'Ngày công tính lương',
    'payslip.actualSalary': 'Lương ngày công',
    'payslip.deductions': 'B. Khấu trừ',
    'payslip.socialInsurance': 'BHXH (8%)',
    'payslip.healthInsurance': 'BHYT (1.5%)',
    'payslip.unemploymentInsurance': 'BHTN (1%)',
    'payslip.personalIncomeTax': 'Thuế TNCN',
    'payslip.otherDeduction': 'Khấu trừ khác',
    'payslip.payableIncome': 'Thu nhập thực lĩnh',

    // Attendance
    'attendance.title': 'Chấm công',
    'attendance.checkIn': 'Giờ vào',
    'attendance.checkOut': 'Giờ ra',
    'attendance.workingHours': 'Số giờ làm',
    'attendance.late': 'Đi muộn',
    'attendance.forgot': 'Quên chấm công',
    'attendance.ipClockIn': 'IP Vào',
    'attendance.ipClockOut': 'IP Ra',
    'attendance.morningApp': 'Đơn buổi sáng',
    'attendance.afternoonApp': 'Đơn buổi chiều',

    // Leave
    'leave.title': 'Nghỉ phép',
    'leave.type': 'Loại nghỉ',
    'leave.startDate': 'Ngày bắt đầu',
    'leave.endDate': 'Ngày kết thúc',
    'leave.session': 'Buổi',
    'leave.reason': 'Lý do',
    'leave.status': 'Trạng thái',
    'leave.pending': 'Chờ duyệt',
    'leave.approved': 'Đã duyệt',
    'leave.rejected': 'Từ chối',
    'leave.requestsTitle': 'Yêu cầu nghỉ phép',
    'leave.createRequest': 'Tạo yêu cầu',
    'leave.deleteRequest': 'Xóa yêu cầu',
    'leave.updateRequest': 'Cập nhật yêu cầu',
    'leave.createLeaveRequest': 'Tạo yêu cầu nghỉ phép',
    'leave.deleteConfirm': 'Bạn có muốn xóa yêu cầu này không?',
    'leave.morningApplication': 'Đơn buổi sáng',
    'leave.afternoonApplication': 'Đơn buổi chiều',
    'leave.fullDayApplication': 'Đơn cả ngày',
    'leave.daysApplication': 'Ngày',
    'leave.showDetail': 'Xem chi tiết',
    'leave.requestingRemaining': 'Yêu cầu / Còn lại',
    'leave.days': 'ngày',
    'leave.casualLeave': 'Nghỉ thường',
    'leave.sickLeave': 'Nghỉ bệnh',
    'leave.annualLeave': 'Nghỉ phép năm',
    'leave.forgotCheckInOut': 'Quên chấm công',
    'leave.comeLateLeaveEarly': 'Đến muộn/Về sớm',
    'leave.workFromHome': 'Làm tại nhà',
    'leave.multiDays': 'Nhiều ngày',
    'leave.end': 'Đến',
    'leave.validationStartEmpty': 'Ngày bắt đầu không được để trống!',
    'leave.validationEndEmpty': 'Ngày kết thúc không được để trống!',
    'leave.validationReasonEmpty': 'Lý do không được để trống!',
    'leave.validationAnnualNotEnough': 'Số ngày phép năm không đủ!',

    // Overtime
    'overtime.title': 'Làm thêm giờ',
    'overtime.hours': 'Số giờ',
    'overtime.type': 'Loại',
    'overtime.weekday': 'Ngày thường',
    'overtime.weekend': 'Ngày cuối tuần',
    'overtime.holiday': 'Ngày lễ',
    'overtime.otRequests': 'Yêu cầu OT',
    'overtime.createRequest': 'Tạo yêu cầu OT',
    'overtime.deleteRequest': 'Xóa yêu cầu',
    'overtime.deleteConfirm': 'Bạn có muốn xóa yêu cầu này không?',
    'overtime.multiplier': 'Hệ số',
    'overtime.time': 'Giờ',

    // Amercement
    'amercement.title': 'Phạt',
    'amercement.reason': 'Lý do',
    'amercement.amount': 'Số tiền',
    'amercement.checkInLate': 'Đi muộn',
    'amercement.forgotCheckOut': 'Quên chấm công',
    'amercement.absent': 'Vắng mặt',
    'amercement.totalAmercement': 'Tổng tiền phạt',
    'amercement.forgotCheckInOutEarly': 'Quên/Về sớm',
    'amercement.times': 'lần',
    'amercement.absentForgotHeader': 'Vắng/Quên/Về sớm',

    // Personal tax
    'tax.taxableIncome': 'Thu nhập chịu thuế',
    'tax.selfDeduction': 'Giảm trừ bản thân',
    'tax.dependentDeduction': 'Giảm trừ người phụ thuộc x',
    'tax.netTaxableIncome': 'Thu nhập tính thuế',
    'tax.upTo': 'Đến',

    // Installment
    'installment.title': 'Trả góp',
    'installment.amount': 'Số tiền',
    'installment.remaining': 'Còn lại',
    'installment.start': 'Bắt đầu',
    'installment.end': 'Kết thúc',
    'installment.thisMonth': 'Tháng này',

    // Overtime
    'overtime.cardTitle': 'Làm thêm giờ',
    'overtime.create': 'Tạo',
    'overtime.showDetail': 'Xem chi tiết',
    'overtime.updateRequest': 'Cập nhật yêu cầu OT',
    'overtime.date': 'Ngày',
    'overtime.otHour': 'Số giờ OT',
    'overtime.tasks': 'Công việc',
    'overtime.request': 'Gửi yêu cầu',
    'overtime.update': 'Cập nhật',
    'overtime.declined': 'Từ chối',
    'overtime.approved': 'Đã duyệt',
    'overtime.awaiting': 'Chờ duyệt',

    // Bank
    'bank.bankName': 'Ngân hàng',
    'bank.bankAccount': 'Số tài khoản',

    // Payroll history table headers
    'payrollHistory.date': 'Ngày',
    'payrollHistory.salary': 'Lương',
    'payrollHistory.bonus': 'Thưởng',
    'payrollHistory.employeeType': 'Loại nhân viên',
    'payrollHistory.annualLeaves': 'Ngày phép',
    'payrollHistory.description': 'Mô tả',
    'payrollHistory.applyDate': 'Ngày áp dụng',

    // Validation messages
    'validation.dateEmpty': 'Ngày không được để trống!',
    'validation.reasonEmpty': 'Lý do không được để trống!',

    // Home
    'home.happyLunch': 'Chúc bữa trưa ngon miệng',
    'home.happyWorking': 'Chúc một ngày làm việc vui vẻ',
    'home.outsideWorkingHours': 'Ngoài giờ làm việc',
    'home.outsideOffice': 'Ngoài văn phòng',
    'home.tooEarlyCheckin': 'Còn quá sớm để check in!',
    'home.connectNetwork': 'Vui lòng kết nối mạng công ty trước!',
    'home.checkIn': 'Check In',
    'home.checkOut': 'Check Out',
    'home.thankyou': 'Cảm ơn',
    'home.confirmCheckoutTitle': 'Check Out',
    'home.confirmCheckoutBody': 'Bạn chắc chắn muốn Check Out?',
    'home.contactAdmin': 'Liên hệ với admin!',
    'home.oops': 'Oops...',

    // Home - attendance summary
    'home.avgClockIn': 'Giờ vào TB',
    'home.avgClockOut': 'Giờ ra TB',
    'home.avgWorkingHr': 'Giờ làm TB',
    'home.absentLeaves': 'Vắng / Nghỉ phép',
    'home.absent': 'Vắng mặt',
    'home.doNothingChill': 'Vui vẻ nghỉ ngơi',
    'home.workingHrs': 'Số giờ làm',
    'home.morning': 'Buổi sáng',
    'home.afternoon': 'Buổi chiều',
    'home.fullDay': 'Cả ngày',
    'home.days': 'Ngày',
    'home.statusDeclined': 'Từ chối',
    'home.statusApproved': 'Đã duyệt',
    'home.statusAwaiting': 'Chờ duyệt',
    'home.by': 'bởi',
    'home.approveBtn': 'Duyệt',
    'home.declineBtn': 'Từ chối',
    'home.hr': 'giờ',
    'home.ongoingEventsTitle': 'Sự kiện sắp diễn ra',
    'home.noOngoingEvents': 'Hiện tại không có sự kiện nào.',
    'home.todayIsYourBirthday': 'Hôm nay là sinh nhật của bạn. Chúc mừng sinh nhật!',
    'home.countdownToday': 'Hôm nay',
    'home.countdownTomorrow': 'Ngày mai',
    'home.countdownInDays': 'Còn {days} ngày',
    'home.daysWithCompany': 'Chúng ta đã đồng hành cùng nhau',
    'home.daysUnit': 'ngày',
    'home.yearsUnit': 'năm',
    'home.monthsUnit': 'tháng',
    'home.daysShortUnit': 'ngày',

    // Weather
    'weather.forecastTitle': 'Dự báo thời tiết',
    'weather.unavailable': 'Không thể tải dữ liệu thời tiết.',
    'weather.sunny': 'Nắng',
    'weather.partlyCloudy': 'Có mây',
    'weather.cloudy': 'Nhiều mây',
    'weather.fog': 'Sương mù',
    'weather.drizzle': 'Mưa phùn',
    'weather.rain': 'Mưa',
    'weather.snow': 'Tuyết',
    'weather.shower': 'Mưa rào',
    'weather.thunderstorm': 'Dông',
    'weather.unknown': 'Không xác định',
    'weather.extremeHeatTitle': 'Cảnh báo nắng nóng cực đoan',
    'weather.extremeHeatMessage': 'Nhiệt độ hôm nay quá cao, vui lòng bổ sung nước đầy đủ.',
    'weather.extremeColdTitle': 'Cảnh báo rét cực đoan',
    'weather.extremeColdMessage': 'Nhiệt độ hôm nay quá thấp, vui lòng giữ ấm cơ thể.',
};

export default vi;

